import React, { Component, Fragment } from "react";

class Footer extends Component {
    state = {
        totalPages: 1,
        curentPage: 1,
        pagingStages: 5
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.totalPages !== this.props.totalPages) {
            this.setState({ totalPages: nextProps.totalPages });
        }
        if (nextProps.curentPage !== this.props.curentPage) {
            this.setState({ curentPage: nextProps.curentPage });
        }
    }

    changePage = event => {
        this.props.changePage(event.currentTarget.getAttribute("page"));
    };

    createPaging = () => {
        let links = [];

        let from = 0;
        let to = 0;
        if (this.state.totalPages >= this.state.pagingStages) {
            from =
                parseInt(this.state.curentPage, 10) -
                parseInt((this.state.pagingStages - 1) / 2, 10);
            to =
                parseInt(this.state.curentPage, 10) +
                parseInt((this.state.pagingStages - 1) / 2, 10);
            if (from < 1) {
                from = 1;
                to = this.state.pagingStages;
            }
            if (to >= this.state.totalPages) {
                to = this.state.totalPages;
            }
            if (to >= this.state.totalPages) {
                from = this.state.totalPages - (this.state.pagingStages - 1);
            }
        } else {
            from = 1;
            to = this.state.totalPages;
        }
        if (
            this.state.curentPage <= 1 &&
            this.state.totalPages >= this.state.pagingStages
        ) {
            links.push(
                <li className="page-item disabled" key="0">
                    {" "}
                    <a className="page-link">First</a>
                </li>
            );
        } else if (this.state.totalPages >= this.state.pagingStages) {
            links.push(
                <li className="page-item" key="0">
                    {" "}
                    <a onClick={this.changePage} page={1} className="page-link">
                        First
                    </a>
                </li>
            );
        }
        for (let i = from; i <= to; i++) {
            if (parseInt(this.state.curentPage, 10) === i) {
                links.push(
                    <li key={i} className="page-item active ">
                        <a className="page-link">{i}</a>
                    </li>
                );
            } else {
                links.push(
                    <li key={i} className="page-item">
                        <a
                            onClick={this.changePage}
                            page={i}
                            className="page-link"
                        >
                            {i}
                        </a>
                    </li>
                );
            }
        }

        if (
            this.state.curentPage >= this.state.totalPages &&
            this.state.totalPages >= this.state.pagingStages
        ) {
            links.push(
                <li className="page-item disabled" key="10000">
                    {" "}
                    <a className="page-link">Last</a>
                </li>
            );
        } else if (this.state.totalPages >= this.state.pagingStages) {
            links.push(
                <li className="page-item" key="10000">
                    {" "}
                    <a
                        onClick={this.changePage}
                        page={this.state.totalPages}
                        className="page-link"
                    >
                        Last
                    </a>
                </li>
            );
        }
        //console.log(from,to);
        return (to > from) ? links : '';
    };

    render() {
        return (
            <Fragment>
                <div className="footer">
                    <div className="footer-inner">
                        <div className="col-right pagination">
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center">
                                    {this.createPaging()}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/utilities/Footer.js